import { Link } from "react-router-dom"
import { urlsPages } from "../../../common/urls/urls-pages"

export function Hero() {
  return (
    <section id="top" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-grid opacity-40 [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_75%)]" />
      <div
        className="absolute inset-0 -z-10"
        style={{ background: "var(--gradient-hero)" }}
      />

      <div className="mx-auto max-w-7xl px-6 grid md:grid-cols-2 gap-14 items-center">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-glow px-3 py-1.5 text-xs text-primary mb-6">
            <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
            Treinos com estímulos
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight">
            Treine corpo e mente com{" "}
            <span className="text-primary text-glow">estímulos.</span>
          </h1>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-xl">
            O Kinerfy transforma estímulos em desafios. Crie treinos que desenvolvem agilidade, tempo de
            reação e raciocínio rápido, seja na quadra, na academia, na sala de aula ou no alto
            rendimento, e acompanhe a evolução de cada pessoa com dados reais.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to={urlsPages.signup}
              className="inline-flex items-center rounded-full bg-primary px-7 py-3.5 text-base font-semibold text-primary-foreground glow-primary hover:scale-[1.03] transition-transform"
            >
              Começar grátis
            </Link>
            <a
              href="#como-funciona"
              className="inline-flex items-center rounded-full border border-white/15 px-7 py-3.5 text-base font-semibold text-foreground hover:border-primary hover:text-primary transition-colors"
            >
              Ver como funciona →
            </a>
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div
            className="absolute -inset-10 -z-10 blur-3xl opacity-60"
            style={{ background: "radial-gradient(circle, rgba(0,255,179,0.2), transparent 60%)" }}
          />
          <img
            src="/assets/images/hero1.jpeg"
            alt="Pessoa em treino de agilidade com estímulos visuais no monitor"
            className="relative w-full rounded-3xl border border-white/10 object-cover shadow-2xl"
          />
        </div>
      </div>
    </section>
  )
}
